export default __webpack_public_path__ + "static/cruiselines-vrc-ship-3-990654cd5c0d7ac2d16004b50bee2a1e.jpg";